"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    jiaHeavenly: 'jia',
    yiHeavenly: 'yi',
    bingHeavenly: 'bing',
    dingHeavenly: 'ding',
    wuHeavenly: 'wu',
    jiHeavenly: 'ji',
    gengHeavenly: 'geng',
    xinHeavenly: 'xin',
    renHeavenly: 'ren',
    guiHeavenly: 'gui',
};
